import { ReactNode } from "react";

import { VersionBadge } from "./VersionBadge";

/**
 * Shared shell for all unauthenticated screens (Login, Signup,
 * ForgotPassword, ResetPassword, AcceptInvite). Centered card on a
 * canvas backdrop — same brand vocabulary as the panneau cards.
 *
 * The version chip lives below the optional `footer` prop so users
 * see the deploy identity on every login attempt — useful for support
 * tickets ("hi, I'm seeing X on v0.6.0+abc1234").
 */
export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-canvas dark:bg-canvas-dark flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <div className="inline-flex items-center gap-2 text-2xl font-bold text-ink dark:text-ink-dark">
            <span className="h-6 w-6 rounded-full bg-chip-orange" aria-hidden />
            Bunapp
          </div>
          <h1 className="mt-4 text-xl font-semibold text-ink dark:text-ink-dark">{title}</h1>
          {subtitle && (
            <p className="mt-1 text-sm text-muted dark:text-muted-dark">{subtitle}</p>
          )}
        </div>
        <div className="bg-white dark:bg-surface-dark rounded-2xl ring-1 ring-black/10 dark:ring-white/10 shadow-sm p-6">
          {children}
        </div>
        {footer && (
          <div className="mt-4 text-center text-sm text-muted dark:text-muted-dark">{footer}</div>
        )}
        <div className="mt-6 text-center">
          <VersionBadge />
        </div>
      </div>
    </div>
  );
}
